import React from 'react';
import { educationData } from '../utils/constants';
import { GraduationCapIcon, AwardIcon, BookOpenIcon } from 'lucide-react';
const Education = ({
  language = 'en'
}) => {
  const translations = {
    en: {
      education: 'My',
      educationHighlight: 'Education',
      minor: 'Minor:',
      gpa: 'GPA:',
      honorsAwards: 'Honors & Awards',
      relevantCourses: 'Relevant Courses',
      certifications: 'Certifications',
      externalPrograms: 'External Programs'
    },
    vi: {
      education: 'Học',
      educationHighlight: 'Vấn',
      minor: 'Chuyên ngành phụ:',
      gpa: 'GPA:',
      honorsAwards: 'Danh Hiệu & Giải Thưởng',
      relevantCourses: 'Các Khóa Học Liên Quan',
      certifications: 'Chứng Chỉ',
      externalPrograms: 'Chương Trình Bên Ngoài'
    }
  };
  const t = translations[language];
  return <section id="education" className="w-full py-24 bg-background" data-id="element-119">
      <div className="container mx-auto px-4" data-id="element-120">
        <h2 className="text-3xl md:text-4xl font-display font-bold text-center mb-16" data-id="element-121">
          {t.education}{' '}
          <span className="gradient-text" data-id="element-122">{t.educationHighlight}</span>
        </h2>
        <div className="bg-secondary rounded-2xl p-8 card-glow" data-id="element-123">
          <div className="flex flex-col md:flex-row items-start gap-8" data-id="element-124">
            <div className="w-full md:w-1/3" data-id="element-125">
              <div className="flex items-center gap-3 mb-4" data-id="element-126">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center p-1" data-id="element-127">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2ap1op7RttLLXY16S5PhAA/Northeastern_logo2.png" alt="Northeastern University" className="max-w-full max-h-full object-contain" data-id="element-128" />
                </div>
                <h3 className="text-2xl font-display font-bold" data-id="element-129">
                  {educationData.school}
                </h3>
              </div>
              <p className="text-accent-cyan mb-1" data-id="element-130">
                {language === 'en' ? educationData.degree : educationData.degreeVi}
              </p>
              <p className="text-muted mb-1" data-id="element-131">
                {t.minor}{' '}
                {language === 'en' ? educationData.minor : educationData.minorVi}
              </p>
              <p className="text-muted mb-1" data-id="element-132">
                {t.gpa} {educationData.gpa}
              </p>
              <p className="text-muted" data-id="element-133">
                {language === 'en' ? educationData.dates : educationData.datesVi}
              </p>
            </div>
            <div className="w-full md:w-2/3 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-134">
              <div data-id="element-135">
                <div className="flex items-center gap-2 mb-3" data-id="element-136">
                  <AwardIcon size={20} className="text-accent-violet" data-id="element-137" />
                  <h4 className="text-lg font-display font-bold" data-id="element-138">
                    {t.honorsAwards}
                  </h4>
                </div>
                <ul className="space-y-1" data-id="element-139">
                  {(language === 'en' ? educationData.honors : educationData.honorsVi).map((honor, index) => <li key={index} className="flex items-start gap-2" data-id="element-140">
                      <span className="text-accent-cyan mt-1" data-id="element-141">•</span>
                      <span className="text-muted" data-id="element-142">{honor}</span>
                    </li>)}
                </ul>
              </div>
              <div data-id="element-143">
                <div className="flex items-center gap-2 mb-3" data-id="element-144">
                  <BookOpenIcon size={20} className="text-accent-amber" data-id="element-145" />
                  <h4 className="text-lg font-display font-bold" data-id="element-146">
                    {t.relevantCourses}
                  </h4>
                </div>
                <ul className="space-y-1" data-id="element-147">
                  {(language === 'en' ? educationData.courses : educationData.coursesVi).map((course, index) => <li key={index} className="flex items-start gap-2" data-id="element-148">
                      <span className="text-accent-cyan mt-1" data-id="element-149">•</span>
                      <span className="text-muted" data-id="element-150">{course}</span>
                    </li>)}
                </ul>
              </div>
              <div data-id="element-151">
                <div className="flex items-center gap-2 mb-3" data-id="element-152">
                  <div size={20} className="text-accent-cyan" data-id="element-153" />
                  <h4 className="text-lg font-display font-bold" data-id="element-154">
                    {t.certifications}
                  </h4>
                </div>
                <ul className="space-y-1" data-id="element-155">
                  {(language === 'en' ? educationData.certifications : educationData.certificationsVi).map((cert, index) => <li key={index} className="flex items-start gap-2" data-id="element-156">
                      <span className="text-accent-cyan mt-1" data-id="element-157">•</span>
                      <span className="text-muted" data-id="element-158">{cert}</span>
                    </li>)}
                </ul>
              </div>
              <div data-id="element-159">
                <div className="flex items-center gap-2 mb-3" data-id="element-160">
                  <BookOpenIcon size={20} className="text-accent-violet" data-id="element-161" />
                  <h4 className="text-lg font-display font-bold" data-id="element-162">
                    {t.externalPrograms}
                  </h4>
                </div>
                <ul className="space-y-1" data-id="element-163">
                  {(language === 'en' ? educationData.programs : educationData.programsVi).map((program, index) => <li key={index} className="flex items-start gap-2" data-id="element-164">
                      <span className="text-accent-cyan mt-1" data-id="element-165">•</span>
                      <span className="text-muted" data-id="element-166">{program}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Education;